import { authGuard, permissionGuard } from '@abp/ng.core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {
    path: 'notification-inbox',
    loadComponent: () => import('./shared/components/notification-inbox/notification-inbox.component').then(m => m.NotificationInboxComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quiz-questions',
    loadComponent: () => import('./modules/lms/assessments/quiz-questions/quiz-questions.component').then(m => m.QuizQuestionsComponent)
  },

  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [authGuard]
  },
  {
    path: 'my-profile',
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [authGuard]
  },

  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('@volo/abp.ng.account/public').then(m => m.AccountPublicModule.forLazy()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(m => m.GdprModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(m => m.LanguageManagementModule.forLazy()),
  },
  {
    path: 'audit-logs',
    loadChildren: () =>
      import('@volo/abp.ng.audit-logging').then(m => m.AuditLoggingModule.forLazy()),
  },
  {
    path: 'openiddict',
    loadChildren: () =>
      import('@volo/abp.ng.openiddictpro').then(m => m.OpeniddictproModule.forLazy()),
  },
  {
    path: 'text-template-management',
    loadChildren: () =>
      import('@volo/abp.ng.text-template-management').then(m =>
        m.TextTemplateManagementModule.forLazy()
      ),
  },
  {
    path: 'file-management',
    loadChildren: () => import('@volo/abp.ng.file-management').then(m => m.FileManagementModule.forLazy()),
  },
  {
    path: 'gdpr-cookie-consent',
    loadChildren: () =>
      import('./gdpr-cookie-consent/gdpr-cookie-consent.module').then(
        m => m.GdprCookieConsentModule
      ),
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
  {
    path: 'settings',
    loadComponent: () => import('./more/more.component').then(m => m.MoreComponent),
    canActivate: [authGuard]
  },
  {
    path: 'account/management',
    loadComponent: () => import('./account-management/account-management.component').then(m => m.AccountManagementComponent),
    canActivate: [authGuard]
  },
  {
    path: 'change-password',
    loadComponent: () => import('./change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [authGuard]
  },
  {
    path: 'personal-settings',
    loadComponent: () => import('./personal-settings/personal-settings.component').then(m => m.PersonalSettingsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/guidelines',
    loadComponent: () => import('./forum-guidelines/forum-guidelines.component').then(m => m.ForumGuidelinesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'moderator-management',
    loadComponent: () => import('./moderator-management/moderator-management.component').then(m => m.ModeratorManagementComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum',
    loadComponent: () => import('./modules/forum/forum.component').then(m => m.ForumComponent),
    canActivate: [authGuard]
  },
  {
    path: 'events',
    loadComponent: () => import('./modules/events/events.component').then(m => m.EventsComponent),
    canActivate: [authGuard]
  },

  {
    path: 'events/create',
    loadComponent: () => import('./modules/events/create-event/create-event.component').then(m => m.CreateEventComponent),
    canActivate: [authGuard]
  },
  {
    path: 'events/:id',
    loadComponent: () => import('./modules/events/event-detail/event-detail.component').then(m => m.EventDetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/create-post',
    loadComponent: () => import('./modules/forum/create-post/create-post.component').then(m => m.CreatePostComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/edit-post',
    loadComponent: () => import('./modules/forum/edit-post/edit-post.component').then(m => m.EditPostComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/post-list',
    loadComponent: () => import('./modules/forum/post-list/post-list.component').then(m => m.PostListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'assessments',
    loadComponent: () => import('./modules/lms/assessments/assessments.component').then(m => m.AssessmentsComponent)
  },
  {
    path: 'game-learning',
    loadComponent: () => import('./modules/lms/assessments/game-learning/game-learning.component').then(m => m.GameLearningComponent)
  },
  {
    path: 'quiz-learning',
    loadComponent: () => import('./modules/lms/assessments/quiz-learning/quiz-learning.component').then(m => m.QuizLearningComponent)
  },
  {
    path: 'quiz-dashboard',
    loadComponent: () => import('./modules/lms/assessments/quiz-dashboard/quiz-dashboard.component').then(m => m.QuizDashboardComponent)
  },
  {
    path: 'my-progress',
    loadComponent: () => import('./modules/lms/my-progress/my-progress.component').then(m => m.MyProgressComponent)
  },
  {
  path: 'achievements',
  loadComponent: () => import('./modules/lms/achievements/achievements.component').then(m => m.AchievementsComponent)
 },
  {
    path: 'forum/create-category',
    loadComponent: () => import('./modules/forum/create-category/create-category.component').then(m => m.CreateCategoryComponent)
  },
  {
    path: 'forum/edit-category/:id',
    loadComponent: () => import('./modules/forum/edit-category/edit-category.component').then(m => m.EditCategoryComponent)
  },
  {
    path: 'forum/category-detail/:id',
    loadComponent: () => import('./modules/forum/category-detail/category-detail.component').then(m => m.CategoryDetailComponent)
  },
  {
    path: 'forum/post-detail/:postId',
    loadComponent: () => import('./modules/forum/post-detail/post-detail.component').then(m => m.PostDetailComponent)
  },
  {
    path: 'forum/search',
    loadComponent: () => import('./modules/forum/forum-search/forum-search.component').then(m => m.ForumSearchComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/reports',
    loadComponent: () => import('./modules/forum/reports/reports.component').then(m => m.ReportsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'forum/post-review/:id',
    loadComponent: () => import('./modules/forum/post-review/post-review.component').then(m => m.PostReviewComponent),
    canActivate: [authGuard]
  },

  {
    path: 'content-test',
    loadComponent: () => import('./modules/test/content-test.component').then(m => m.ContentTestComponent)
    // canActivate: [authGuard]  // Removed for testing - add back later if needed
  },
  {
    path: 'content/:id',
    loadComponent: () => import('./components/content-viewer.component').then(m => m.ContentViewerComponent)
    // canActivate: [authGuard]  // Temporarily removed for testing
  },
  {
    path: 'ai/skin-analysis',
    loadChildren: () => import('./modules/ai/skin-analysis/skin-analysis.module').then(m => m.SkinAnalysisModule),
  },
  {
    path: 'resources',
    loadChildren: () => import('./modules/resources/resources.module').then(m => m.ResourcesModule),
    // canActivate: [authGuard]  // Add authentication if needed
  },
  {
    path: 'leaderboard',
    loadComponent: () => import('./modules/lms/leaderboard/leaderboard.component').then(m => m.LeaderboardComponent)
  },
  // Public route for invitation acceptance (no authentication required)
  {
    path: 'register/invitation',
    loadChildren: () => import('./modules/invitation/invitation.module').then(m => m.InvitationModule)
  },
  // Invite page (authenticated users can send invitations)
  {
    path: 'invite',
    loadComponent: () => import('./modules/invitation/invite-send/invite-send.component').then(m => m.InviteSendComponent),
    canActivate: [authGuard]
  },
  { 
    path: '**', 
    loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent) 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // ABP framework requires 'enabledBlocking' — its APP_INITIALIZER must finish
    // loading openid-configuration before account routes can resolve.
    // The instant landing page in index.html handles the visual delay.
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }